/* modals.js
 * Written by: Alex Kasemir
 *
 * Exports the modals used in the application
 */

import React from 'react';

import AnonScoreBoxModal from 'components/AnonScoreBoxModal';
import LoginModal from 'containers/LoginModal';
import ConfirmationModal from 'components/ConfirmationModal';


export default {
  signup: {
    component: (modal, onClose) => {
      return <AnonScoreBoxModal data={ modal.extraProps } onClose={ onClose } />;
    },
    hideCloseButton: true,
  },
  login: {
    component: (modal, onClose) => {
      return <LoginModal data={ modal.extraProps } onClose={ onClose } />;
    },
  },
  confirm: {
    component: (modal, onClose) => {
      return <ConfirmationModal data={ modal.extraProps } onClose={ onClose } />;
    },
  },
  welcome: {
    component: (modal, onClose) => {
      return <ConfirmationModal data={ modal.extraProps } onClose={ onClose } />;
    },
  },
};
